import React, { useEffect, useState } from 'react';
import appImg from "../assets/images/app-bg.jpg"; // Background image
import appImgMobile from "../assets/images/sm-app-bg.jpg"; // Background image
import appImg2 from "../assets/images/service-phone.png"; // Phone mockup image
import appstore from "../assets/images/app-store.svg";
import playstore from "../assets/images/google-play.svg";
import { useLocation } from 'react-router-dom';

const DownloadAppBanner = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (location.state?.scrollToApp) {
      const section = document.getElementById("AppDownloadSection");
      if (section) {
        const elementPosition = section.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  }, [location]);

  if (loading) {
    return (
      <section id='AppDownloadSection'>
        {/* Desktop Placeholder */}
        <section className="relative overflow-hidden bg-theme2 bg-cover bg-center pt-16 px-6 md:px-16 rounded-[50px] container mx-auto hidden lg:block animate-pulse">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
            {/* Phone Mockup Placeholder */}
            <div className="flex-shrink-0">
              <div className="w-96 h-96 bg-white bg-opacity-20 rounded-lg"></div>
            </div>

            {/* Text Content Placeholder */}
            <div className="text-white md:text-left ml-10 text-center">
              <div className="h-10 bg-white bg-opacity-20 rounded w-96 mb-3"></div>
              <div className="h-6 bg-white bg-opacity-20 rounded w-80 mb-6"></div>
              <div className="flex justify-center md:justify-start gap-4">
                <div className="h-12 w-32 bg-white bg-opacity-20 rounded"></div>
                <div className="h-12 w-32 bg-white bg-opacity-20 rounded"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Mobile Placeholder */}
        <section className="container p-5 block lg:hidden animate-pulse">
          <div style={{ backgroundImage: `url(${appImgMobile})` }} className="rounded-[10px] relative p-5 px-8 overflow-hidden bg-theme2 max-w-7xl mx-auto flex flex-col md:flex-row gap-10">
            <div className="text-white md:text-left">
              <div className="h-20 bg-white bg-opacity-20 rounded w-full mb-3"></div>
              <div className="h-12 bg-white bg-opacity-20 rounded w-4/5 mb-6"></div>
              <div className="flex justify-center md:justify-start gap-4">
                <div className="h-11 w-28 bg-white bg-opacity-20 rounded"></div>
                <div className="h-11 w-28 bg-white bg-opacity-20 rounded"></div>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
  return (
    <React.Fragment>
      <section id='AppDownloadSection'>
        <section
          className="relative overflow-hidden bg-theme2 bg-cover bg-center pt-16 px-6 md:px-16 rounded-[50px] container mx-auto hidden lg:block"
          style={{ backgroundImage: `url(${appImg})` }}
        >
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
            {/* Phone Mockup */}
            <div className="flex-shrink-0">
              <img src={appImg2} alt="App" className="max-w-xs md:max-w-md drop-shadow-lg" />
            </div>

            {/* Text Content */}
            <div className="text-white md:text-left ml-10 text-center">
              <h2 className="text-3xl md:text-4xl font-bold mb-3">
                Rotiey App : Online & Mobile Ordering
              </h2>
              <p className="text-lg md:text-xl mb-6">
                Get the app for free and place takeout orders online whenever you want.
              </p>
              <div className="flex justify-center md:justify-start gap-4">
                <img src={appstore} alt="App Store" className="h-12 cursor-pointer" />
                <img src={playstore} alt="Google Play" className="h-12 cursor-pointer" />
              </div>
            </div>
          </div>
        </section>

        <section
          className="container p-5 block lg:hidden"

        >
          <div style={{ backgroundImage: `url(${appImgMobile})` }} className="rounded-[10px] relative p-5 px-8 overflow-hidden bg-theme2 bg-cover bg-center max-w-7xl mx-auto flex flex-col md:flex-row gap-10">

            {/* Text Content */}
            <div className="text-white md:text-left">
              <h2 className="text-2xl md:text-4xl font-bold mb-3 appdownload relative">
                Rotiey App : Online & Mobile Ordering
              </h2>
              <p className="text-lg md:text-xl mb-6">
                Get the app for free and place takeout orders online whenever you want.
              </p>
              <div className="flex justify-center md:justify-start gap-4">
                <img src={appstore} alt="App Store" className="h-11 cursor-pointer" />
                <img src={playstore} alt="Google Play" className="h-11 cursor-pointer" />
              </div>
            </div>
          </div>
        </section>
      </section>
    </React.Fragment>
  );
};

export default DownloadAppBanner;
